export default "__VITE_ASSET__BPIRSfBF__"